module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921101149_T.2f89de83.jpg";